import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_ADMIN = "GET_ADMIN";

function getAdminAction(admin) {
  return { type: GET_ADMIN, admin: admin };
}

export const getAdmin = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getAdmin)
      .then(function (response) {
        dispatch(getAdminAction(response.data));
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const deleteAllAdminNotifs = function (data) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteAdminNotifs, data)
      .then(function (response) {
        dispatch(getAdmin);
      })
      .catch(function (err) {
        throw err;
      });
  };
};
